import { createContext, useContext } from "react";

export const StoreDetailsContext = createContext({
  storeDetails: [],
  storeUN: '',
  setStoreUN: () => {},
  fetchStoreDetails: () => {},
  reloadStoreDetails: () => {},
  HideStoreDetailsSkeleton: false,
  isUpdatedStoreDetails: false,
  StoreDetailsError: null,
  removeStoreDetails: () => {},
  setHideStoreDetailsSkeleton: () => {},
});

export const useStoreDetailsContext = () => useContext(StoreDetailsContext);
